export const HTTP_STATUS = Object.freeze({
    PENDING: 'PENDING',
    FULFILLED: 'FULFILLED',
    REJECTED: 'REJECTED'
})


/* Access token (or, for pre-migration sessions, the legacy no-expiry JWT). */
export const TOKEN = "droomwork-admin-token";
/* Opaque refresh token. Absent for sessions that started via the legacy
   ?enter= handoff; the refresh manager treats "no refresh token" as
   "session over", which is what keeps the legacy path working. */
export const REFRESH_TOKEN = "droomwork-admin-refresh";
/* Access-token expiry as epoch ms, so we can refresh pre-emptively later
   without decoding the JWT on every request. */
export const ACCESS_TOKEN_EXPIRY = "droomwork-admin-token-exp";
